import React, { useState, useEffect } from 'react';
import vendorDashboardService from '../../services/vendorDashboardService';
import ExportButton from '../../components/ExportButton/ExportButton';
import { exportCoVendors } from '../../services/exportService';
import { toast } from 'react-toastify';
import './VendorCoVendors.css';
import './VendorCoVendorsModal.css';
import { FaClock } from 'react-icons/fa';
const VendorCoVendors = () => {
  const [coVendors, setCoVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 12
  });
  
  const [pagination, setPagination] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  // const [formData, setFormData] = useState({
  //   company_name: '',
  //   email: '',
  //   phone: '',
  //   website: '',
  //   address: '',
  //   city: '',
  //   state: '',
  //   country: '',
  //   postal_code: '',
  //   category: 'Other',
  //   vendor_type: 'Company',
  //   notes: ''
  // });
  const [formData, setFormData] = useState({
    first_name: '',
    email: '',
    mobile: '',
    last_name: '',
    title: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    loadCoVendors();
  }, [filters]);

  const loadCoVendors = async () => {
    try {
      setLoading(true);
      const data = await vendorDashboardService.getCoVendors(filters);
      setCoVendors(data.coVendors || []);
      setPagination(data.pagination);
      setError(null);
    } catch (err) {
      console.error('Error loading co-vendors:', err);
      setError('Failed to load co-vendors');
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      active: '#16a34a',
      inactive: '#64748b',
      pending: '#d97706'
    };
    return colors[status] || '#64748b';
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Clear error for this field
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const errors = {};
    // if (!formData.company_name.trim()) {
    //   errors.company_name = 'Company name is required';
    // }
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'Invalid email format';
    }
    return errors;
  };

  const handleCreateCoVendor = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setSubmitting(true);
    try {
      // await vendorDashboardService.createCoVendor(formData);
      await vendorDashboardService.createVendorEmp(formData);
      setShowCreateModal(false);
      setFormData({
        first_name: '',
        email: '',
        mobile: '',
        website: '',
        last_name: '',
        title: ''
      });
      setFormErrors({});
      await loadCoVendors();
      toast.success('Co-vendor created successfully!');
    } catch (err) {
      console.error('Error creating co-vendor:', err);
      toast.error(err.response?.data?.error || 'Failed to create co-vendor');
    } finally {
      setSubmitting(false);
    }
  };

  const handleExport = async (format) => {
    try {
      await exportCoVendors(format);
      toast.success(`Co-vendors exported successfully as ${format.toUpperCase()}`);
    } catch (error) {
      toast.error('Failed to export co-vendors');
      console.error('Export error:', error);
    }
  };

  const getSharedProjects = (vendor) => [...new Set(vendor.Tasks?.map((t) => t.project?.name).filter(Boolean) || [])];
  const activeCount = coVendors.filter((vendor) => vendor.status === 'active').length;
  const pendingCount = coVendors.filter((vendor) => vendor.status === 'pending').length;
  const totalSharedProjects = new Set(
    coVendors.flatMap((vendor) => getSharedProjects(vendor))
  ).size;

  return (
    <div className="vendor-covendors">
      <div className="covendors-hero">
        <div className="covendors-header">
          <div className="header-content">
            <span className="section-kicker">Staff Collaboration Network</span>
            <h1 className='text-white custom-text'><i className="fas fa-users"></i> Staff</h1>
            <p>Monitor partner tenants, shared delivery exposure, and collaboration touchpoints across active engagements.</p>
          </div>
          <div className="header-actions">
            <ExportButton
              onExport={handleExport}
              formats={['excel', 'csv', 'pdf']}
              label="Export"
            />
            <button onClick={() => setShowCreateModal(true)} className="btn-create">
              <i className="fas fa-plus"></i> Add Staff
            </button>
            <button onClick={loadCoVendors} className="btn-refresh">
              <i className="fas fa-sync-alt"></i> Refresh Data
            </button>
          </div>
        </div>

        <div className="covendors-summary-grid">
          <div className="summary-card">
            <span className="summary-label">Total Staff</span>
            <strong>{pagination?.total || coVendors.length}</strong>
            <p>Organizations currently aligned with your delivery footprint.</p>
          </div>
          <div className="summary-card">
            <span className="summary-label">Active Partners</span>
            <strong>{activeCount}</strong>
            <p>Staff with active operational status in the network.</p>
          </div>
          <div className="summary-card">
            <span className="summary-label">Pending Review</span>
            <strong>{pendingCount}</strong>
            <p>Partners awaiting onboarding, approval, or activation.</p>
          </div>
          <div className="summary-card">
            <span className="summary-label">Shared Projects</span>
            <strong>{totalSharedProjects}</strong>
            <p>Distinct projects where collaboration overlap is detected.</p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <h3>Loading collaboration network</h3>
          <p>Fetching co-vendor relationships and shared project intelligence...</p>
        </div>
      ) : error ? (
        <div className="error-container">
          <div className="state-icon"><i className="fas fa-triangle-exclamation"></i></div>
          <h3>Unable to load co-vendors</h3>
          <p>{error}</p>
          <button onClick={loadCoVendors} className="btn-retry">Retry</button>
        </div>
      ) : coVendors.length === 0 ? (
        <div className="empty-state">
          <div className="state-icon"><i className="fas fa-users-slash"></i></div>
          <h3>No Co-Vendors Found</h3>
          <p>No partner vendors are currently mapped to the same projects. This view will populate as collaboration expands.</p>
        </div>
      ) : (
        <>
          <div className="section-heading">
            <div>
              <span className="section-kicker">Partner Directory</span>
              <h2>Operational vendor relationships</h2>
            </div>
            <p>Review contact channels, status, and project overlap for each co-vendor.</p>
          </div>

          <div className="covendors-grid covendors-grid--professional">
            {coVendors.map((vendor) => {
              const sharedProjects = getSharedProjects(vendor);

              return (
                <div key={vendor.id} className="covendor-card covendor-card--professional">
                  <div className="covendor-main">
                    <div className="covendor-header">
                      <div className="vendor-identity">
                        <div className="vendor-avatar">
                          <i className="fas fa-building"></i>
                        </div>
                        <div className="vendor-title-block">
                          <h3 className="vendor-name">{vendor.first_name} {vendor.last_name}</h3>
                          <div className="vendor-code-row">
                            <p className="vendor-code">Code: {vendor.emp_code || 'N/A'}

                            </p>

                          </div>
                        </div>
                      </div>

                      <div className="vendor-status-co">
                        <span
                          className="status-badge"
                          style={{ backgroundColor: getStatusColor(vendor.status) }}
                        >
                          {vendor.is_active ? 'Active':'In active'}
                        </span>
                        <span>
                        <FaClock
                          className="last-login-icon"
                          title="Last Login"
                        /> {formatDate(vendor.last_login)}</span>
                      </div>
                    </div>

                    {/* <div className="vendor-metrics vendor-metrics--professional">
                      <div className="metric-tile">
                        <span className="metric-label">Shared Projects</span>
                        <strong>{sharedProjects.length}</strong>
                      </div>
                      <div className="metric-tile">
                        <span className="metric-label">Last Login</span>
                        <strong>{formatDate(vendor.last_login)}</strong>
                      </div>
                    </div> */}

                    <div className="covendor-content">
                      <div className="vendor-info vendor-info--professional">
                        <div className="info-item info-item--plain">
                          <span className="inline-icon" aria-hidden="true">📧</span>
                          <span>{vendor.email || 'No email available'}</span>
                        </div>
                        <div className="info-item info-item--plain">
                          <span className="inline-icon" aria-hidden="true">📞</span>
                          <span>{vendor.phone || 'Not available'}</span>
                        </div>
                        <div className="info-item info-item--plain">
                          <span className="inline-icon" aria-hidden="true">🕸️</span>
                          {vendor.website ? (
                            <a href={vendor.website} target="_blank" rel="noopener noreferrer">
                              {vendor.website}
                            </a>
                          ) : (
                            <span>Not available</span>
                          )}
                        </div>
                      </div>

                      <div className="shared-projects shared-projects--professional">
                        <div className="shared-projects-header">
                          <h4>Shared Projects</h4>
                          <span>{sharedProjects.length}</span>
                        </div>

                        {sharedProjects.length > 0 ? (
                          <div className="projects-list">
                            {sharedProjects.slice(0, 3).map((projectName, idx) => (
                              <span key={idx} className="project-tag">
                                <i className="fas fa-diagram-project"></i>
                                {projectName}
                              </span>
                            ))}
                            {sharedProjects.length > 3 && (
                              <span className="project-tag more">
                                +{sharedProjects.length - 3} more
                              </span>
                            )}
                          </div>
                        ) : (
                          <p className="no-projects-text">No shared projects are currently mapped.</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="covendor-footer covendor-footer--professional">
                    <button
                      className="btn-view-details"
                      onClick={() => setSelectedVendor(vendor)}
                    >
                      <i className="fas fa-eye"></i> View Details
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {pagination && pagination.totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setFilters({ ...filters, page: filters.page - 1 })}
                disabled={filters.page === 1}
                className="btn-page"
              >
                <i className="fas fa-chevron-left"></i> Previous
              </button>
              <span className="page-info">
                Page {pagination.page} of {pagination.totalPages}
              </span>
              <button
                onClick={() => setFilters({ ...filters, page: filters.page + 1 })}
                disabled={filters.page === pagination.totalPages}
                className="btn-page"
              >
                Next <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          )}
        </>
      )}

      {selectedVendor && (
        <div className="modal-overlay" onClick={() => setSelectedVendor(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <span className="section-kicker">Staff Profile</span>
                <h2>Staff Details</h2>
              </div>
              <button
                className="btn-close"
                onClick={() => setSelectedVendor(null)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="modal-body">
              <div className="vendor-detail-header">
                <div className="vendor-avatar-large">
                  <i className="fas fa-building"></i>
                </div>
                <div className="vendor-detail-info">
                  <h3>{selectedVendor.company_name}</h3>
                  <p className="vendor-code">Code: {selectedVendor.emp_code || 'N/A'}</p>
                  <span
                    className="status-badge"
                    style={{ backgroundColor: getStatusColor(selectedVendor.status) }}
                  >
                    {selectedVendor.is_active ? 'Active':'In active' || 'UNKNOWN'}
                  </span>
                </div>
              </div>

              <div className="detail-grid">
                <div className="detail-section">
                  <label>Contact Information</label>
                  <div className="contact-info">
                    <div className="contact-item">
                      <i className="fas fa-envelope"></i>
                      <span>{selectedVendor.email || 'No email available'}</span>
                    </div>
                    {selectedVendor.phone && (
                      <div className="contact-item">
                        <i className="fas fa-phone"></i>
                        <span>{selectedVendor.phone}</span>
                      </div>
                    )}
                    {selectedVendor.website && (
                      <div className="contact-item">
                        <i className="fas fa-globe"></i>
                        <a href={selectedVendor.website} target="_blank" rel="noopener noreferrer">
                          {selectedVendor.website}
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                <div className="detail-section">
                  <label>Operational Snapshot</label>
                  <div className="detail-stat-list">
                    <div className="detail-stat-item">
                      <span>Shared Projects</span>
                      <strong>{getSharedProjects(selectedVendor).length}</strong>
                    </div>
                    <div className="detail-stat-item">
                      <span>Last Login</span>
                      <strong>{formatDate(selectedVendor.last_login)}</strong>
                    </div>
                    <div className="detail-stat-item">
                      <span>Status</span>
                      <strong>{selectedVendor.is_active ? 'Active': 'In active' || 'UNKNOWN'}</strong>
                    </div>
                  </div>
                </div>
              </div>

              {selectedVendor.address && (
                <div className="detail-section">
                  <label>Address</label>
                  <p>
                    {selectedVendor.address}
                    {selectedVendor.city && `, ${selectedVendor.city}`}
                    {selectedVendor.state && `, ${selectedVendor.state}`}
                    {selectedVendor.country && `, ${selectedVendor.country}`}
                  </p>
                </div>
              )}

              <div className="detail-section">
                <label>Shared Projects ({getSharedProjects(selectedVendor).length})</label>
                {getSharedProjects(selectedVendor).length > 0 ? (
                  <div className="projects-detail-list">
                    {getSharedProjects(selectedVendor).map((projectName, idx) => (
                      <div key={idx} className="project-detail-item">
                        <i className="fas fa-diagram-project"></i>
                        <span>{projectName}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No shared projects are currently mapped for this vendor.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showCreateModal && (
        <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <span className="section-kicker">Add New Staff</span>
                <h2>Create staff</h2>
              </div>
              <button
                className="btn-close"
                onClick={() => setShowCreateModal(false)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <form onSubmit={handleCreateCoVendor} className="modal-body">
              {/* <div className="form-grid"> */}
              {/* <div className="form-section">
                  <h3>Company Information</h3>

                  <div className="form-group">
                    <label htmlFor="company_name">
                      Company Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="company_name"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleInputChange}
                      className={formErrors.company_name ? 'error' : ''}
                      placeholder="Enter company name"
                    />
                    {formErrors.company_name && (
                      <span className="error-message">{formErrors.company_name}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={formErrors.email ? 'error' : ''}
                      placeholder="vendor@company.com"
                    />
                    {formErrors.email && (
                      <span className="error-message">{formErrors.email}</span>
                    )}
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="vendor_type">Vendor Type</label>
                      <select
                        id="vendor_type"
                        name="vendor_type"
                        value={formData.vendor_type}
                        onChange={handleInputChange}
                      >
                        <option value="Company">Company</option>
                        <option value="Individual">Individual</option>
                        <option value="Partnership">Partnership</option>
                        <option value="Corporation">Corporation</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="category">Category</label>
                      <select
                        id="category"
                        name="category"
                        value={formData.category}
                        onChange={handleInputChange}
                      >
                        <option value="IT Services">IT Services</option>
                        <option value="Consulting">Consulting</option>
                        <option value="Manufacturing">Manufacturing</option>
                        <option value="Logistics">Logistics</option>
                        <option value="Marketing">Marketing</option>
                        <option value="HR Services">HR Services</option>
                        <option value="Legal">Legal</option>
                        <option value="Financial">Financial</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                </div> */}

              <div className="form-section">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="form-group">
                    <label htmlFor="first_name">First Name</label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                      placeholder="John"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="last_name">Last Name</label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                      placeholder="John"
                    />
                  </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="form-group">
                    <label htmlFor="title">Title </label>
                    <input
                      type="text"
                      id="title"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      placeholder="Mr."
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="johndoe@example.com"
                    />
                  </div>

                  {/* <div className="form-row"> */}
                  <div className="form-group">
                    <label htmlFor="mobile">Mobile</label>
                    <input
                      type="number"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      placeholder="+91 1234567890"
                    />
                  </div>


                </div>
                {/* </div> */}

                {/* <div className="form-row"> */}
                {/* <div className="form-group">
                      <label htmlFor="country">Country</label>
                      <input
                        type="text"
                        id="country"
                        name="country"
                        value={formData.country}
                        onChange={handleInputChange}
                        placeholder="Country"
                      />
                    </div> */}

                {/* <div className="form-group">
                      <label htmlFor="postal_code">Postal Code</label>
                      <input
                        type="text"
                        id="postal_code"
                        name="postal_code"
                        value={formData.postal_code}
                        onChange={handleInputChange}
                        placeholder="12345"
                      />
                    </div> */}
                {/* </div> */}
              </div>

              {/* <div className="form-section form-section--full">
                  <h3>Additional Information</h3>

                  <div className="form-group">
                    <label htmlFor="notes">Notes</label>
                    <textarea className="textarea-notes"
                      id="notes"
                      name="notes"
                      value={formData.notes}
                      onChange={handleInputChange}
                      rows="4"
                      placeholder="Add any additional notes or comments about this co-vendor..."
                    />
                  </div>
                </div> */}
              {/* </div> */}

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={() => setShowCreateModal(false)}
                  disabled={submitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-primary"
                  disabled={submitting}
                >
                  {submitting ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i> Creating...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-plus"></i> Create staff
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorCoVendors;

